import { OnInit, Component, TemplateRef } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { Observable, forkJoin } from 'rxjs';
import { DashboardService } from '../dashboard.service';
import { IDtoReceipt } from 'app/shared/models/dashboard/dto-receipt.model';
import { IDtoBonusCommission } from 'app/shared/models/dashboard/dto-bonus-commission.model';
import { SecurityService } from 'app/shared/services/security.service';
import { EmployeeService } from '../employee.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { saveAs } from 'file-saver';
import { IDtoJobCandidateBasic } from 'app/shared/models/employee/dto-jobcandidate-basic.model';
import { IEmployeeTaxData } from 'app/shared/models/recruitment/employee-tax-data.model';
import { RecruitmentService } from '../recruitment/recruitment.service';
import { IDocument } from 'app/shared/models/recruitment/document.model';
import { IResult } from 'app/shared/models/result.model';
import { ModalBasicDataComponet } from 'app/views/modales/employees/basic-data/modal-basic-data.component';
import { ISelect } from 'app/shared/models/select.model';
import { IAppearance } from 'app/shared/models/recruitment/appearance.model';
import { ModalAppearanceComponet } from 'app/views/modales/recruitment/appearance/modal-appearance.component';
import { OpeningService } from '../opening/opening.service';
import { IDtoRequisition } from 'app/shared/models/opening/dto-requisition.model';
import { OrganizationService } from '../organization/organization.service';
import { IDtoCompany } from 'app/shared/models/organization/dto-company.model';
import { IDtoWorkingDay } from 'app/shared/models/position/dto-working-day.model';
import { StorageService } from 'app/shared/services/storage.service';
@Component({
    selector: 'app-dashboard',
    styleUrls: ['dashboard.style.scss'],
    templateUrl: 'dashboard.template.html'
})
export class DashboardComponent implements OnInit {
    private config = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
    };
    /**Validadores */
    private catalogYears: Observable<IDtoCatalog[]>;
    private catalogMonths: Observable<IDtoCatalog[]>;
    //private month: number;
    private year: number;
    private receipts: IDtoReceipt[];
    private bonusCommissions: IDtoBonusCommission[];
    private showRoles: any;
    private employeeId: number;
    private employee: IDtoJobCandidateBasic;
    private receipt: IDtoReceipt;
    private days = 0;
    employeeTaxData: IEmployeeTaxData;
    fileNameSAT = '';
    document: IDocument;
    requisition: IDtoRequisition;
    company: IDtoCompany;
    workingDay: IDtoWorkingDay;
    child: string;
    constructor(private configGeneral: AppConfig
        , private spinner: NgxSpinnerService
        , private configurationService: ConfigurationService
        , private dashboardService: DashboardService
        , private securityService: SecurityService
        , private employeeService: EmployeeService
        , private modalService: BsModalService
        , private recruitmentService: RecruitmentService
        , private openingService: OpeningService
        , private organizationService: OrganizationService
        , private storageService: StorageService) {
        if (this.configurationService.isReady) {
            this.init();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.init();
            });
        }
    }
    private init(): void {
        this.showRoles = this.securityService.getUserRolesStorage();
        if (this.showRoles !== '') {
            this.employeeId = this.showRoles.employeeId;
            this.getEmployee();
            this.getEmployeeTaxDataActive();
            this.getJobCandidateDocument();
        }
    }
    ngOnInit(): void {
        if (this.configurationService.isReady) {
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
            });
        }
        this.catalogYears = this.dashboardService.getCatalogYears();
        this.catalogMonths = this.dashboardService.getCatalogMonths();
    }
    private getEmployee(): void {
        this.employeeService.getEmployee(this.employeeId).subscribe((res) => {
            this.employee = res.data as IDtoJobCandidateBasic;
            this.getAvailableDays();
            this.getRequisition();
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.message, 'error');
            });
    }
    private getEmployeeTaxDataActive(): void {
        this.employeeService.getEmployeeTaxDataActive(this.employeeId).subscribe((res) => {
            this.employeeTaxData = res.data as IEmployeeTaxData;
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.message, 'error');
            });
    }
    private getAvailableDays(): void {
        if (this.employee) {
            this.dashboardService.getAvailableDays(this.configGeneral.dateFormat(new Date(this.employee.laborSeniorityDate), 'yyyy-mm-dd'), this.employee.id, this.employee.employeeNum, this.employee.requisitionId).subscribe((res) => {
                this.days = res;
            },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.message, 'error');
                });
        }
    }
    private getRequisition(): void {
        if (this.employee) {
            this.openingService.getRequisitionById(this.employee.requisitionId).subscribe((res) => {
                this.requisition = res;
                this.storageService.store('requisition', res);
                this.getPayCompany(this.requisition.companyId);
            },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.message, 'error');
                });
        }
    }
    private getCredential(): void {
        this.dashboardService.getCredential(this.employee.id, this.requisition.companyId).subscribe((res) => {
            if (res.isCorrect) {
              let file = res.data as any;
                const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
                this.spinner.hide();
                saveAs(blob, file.fileDownloadName);
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.message, 'error');
            });
    }
    private getTemplateFonacot(): void {
        this.spinner.show();
        let dto = {} as IDtoJobCandidateBasic;
        dto.companyName = this.company.name;
        dto.firstName = this.employee.firstName;
        dto.lastName = this.employee.lastName;
        dto.secondLastName = this.employee.secondLastName;
        dto.imss = this.employee.imss;
        dto.rfc = this.employee.rfc;
        dto.curp = this.employee.curp;
        dto.jobName = this.requisition.jobDesc;
        dto.hiringDate = this.employee.hiringDate;
        dto.companyId = this.requisition.companyId;
        dto.employerRegister = this.requisition.employerRegister;
        this.dashboardService.getTemplateFonacot(dto).subscribe((res) => {
            if (res.isCorrect) {
                let file = res.data as any;
                const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
                this.spinner.hide();
                saveAs(blob, file.fileDownloadName);
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.message, 'error');
            });
    }
    private getTemplateLabor(): void {
        this.spinner.show();
        let dto = {} as IDtoJobCandidateBasic;
        dto.companyName = this.company.name;
        dto.firstName = this.employee.firstName;
        dto.lastName = this.employee.lastName;
        dto.secondLastName = this.employee.secondLastName;
        dto.imss = this.employee.imss;
        dto.rfc = this.employee.rfc;
        dto.curp = this.employee.curp;
        dto.jobName = this.requisition.jobDesc;
        dto.hiringDate = this.employee.hiringDate;
        dto.companyId = this.requisition.companyId;
        dto.employerRegister = this.requisition.employerRegister;
        this.dashboardService.getTemplateLabor(dto).subscribe((res) => {
            if (res.isCorrect) {
                let file = res.data as any;
                const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
                this.spinner.hide();
                saveAs(blob, file.fileDownloadName);
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.message, 'error');
            });
    }
    //'00009000040000000001'
    private getPayrollReceipts(): void {
        this.spinner.show();
        this.dashboardService.getPayrollReceipts(this.employee.uKey, this.year).subscribe((res) => {
            this.receipts = res;
            this.spinner.hide();
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.message, 'error');
            });
    }
    //130477
    private getBonusCommissions(item: IDtoReceipt): void {
        this.bonusCommissions = [];
        this.spinner.show();
        this.dashboardService.getBonusCommissions(this.employeeId, this.configGeneral.dateFormat(new Date(item.period), 'yyyy-mm-dd')).subscribe((res) => {
            this.bonusCommissions = res;
            this.spinner.hide();
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.message, 'error');
            });
    }
    private openModalBonusCommissions(item: IDtoReceipt, template: TemplateRef<any>) {
        this.receipt = item;
        this.bonusCommissions = [];
        this.spinner.show();
        this.dashboardService.getBonusCommissions(this.employeeId, this.configGeneral.dateFormat(new Date(item.period), 'yyyy-mm-dd')).subscribe((res) => {
            this.bonusCommissions = res;
            this.modalService.show(template);
            this.spinner.hide();
        });
    }
    private downloadFileReceipt(item: IDtoReceipt, type: string): void {
        this.spinner.show();
        this.dashboardService.downloadFileReceipt(item.uuid, type).subscribe((res) => {
            if (res.isCorrect) {
                const blob = this.configGeneral.b64toBlob(res.data, type == 'pdf' ? 'application/pdf' : 'application/xml', '');
                this.spinner.hide();
                saveAs(blob, item.uuid);
            }
            this.spinner.hide();
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.message, 'error');
            });
    }
    private onFileChange(event) {
        event.value = '';
    }
    private handleFileInput(files: FileList) {
        const file = files.item(0);
        let ext = file.name.split('.').pop();
        if (ext == 'pdf') {
            this.upload(file);
        } else {
            this.configGeneral.newToast('Validación', `Asegúrese de seleccionar el tipo de archivo correcto (.pdf)`, 'error');
        }
    }
    private upload(file: File): void {
        let item = {} as IResult;
        item.data = new Object('.' + file.name.split('.').pop());
        item.message = file.name;
        this.spinner.show();
        if (this.employeeId === undefined || this.employeeId === 0) {
            this.spinner.hide();
            this.configGeneral.newToast('Validación', 'Los datos del empleado no han sido cargados correctamente', 'warning');
            return;
        }
        if (file.size > 2097152) {
            this.spinner.hide();
            this.configGeneral.newToast('Validación', 'No es posible subir documentos con un peso mayor a 2MB', 'warning');
            return;
        }
        this.recruitmentService.uploadFileAndTaxDataEmployee(item, file).subscribe((res) => {
            if (res.isCorrect === true) {
                this.document = res.data as IDocument;
                this.spinner.hide();
                this.getEmployeeTaxDataActive();
                this.configGeneral.newToast('Éxito', 'Documento cargado correctamente', 'success');
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
                this.spinner.hide();
            }
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.message, 'error');
            });
    }
    private downloadFile(): void {
        if (this.document.id == undefined) {
            this.configGeneral.newToast('Error', 'No existe un documento SAT para este empleado', 'error');
            return;
        }
        this.recruitmentService.downloadFile(this.document.id).subscribe((res) => {
            if (res.isCorrect === true) {
                const file = res.data as any;
                const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
                saveAs(blob, file.fileDownloadName);
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
        });
    }
    private getJobCandidateDocument(): void {
        this.recruitmentService.getJobCandidateDocument(this.employeeId, 'RFC').subscribe((res) => {
            this.document = res;
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.message, 'error');
            });
    }
    private openModalBasicData() {
        const initialState = {
            title: 'Información básica',
            uKey: this.employee.uKey,
            employee: this.employee
        };

        this.modalService.show(ModalBasicDataComponet
            , Object.assign({ initialState }
                , { class: 'gray modal-lg' }, this.config));
    }
    private getCatalogs(): void {
        this.spinner.show();
        forkJoin([
            this.recruitmentService.getCatalogSizes(),
            this.recruitmentService.getCatalogPhysicalComplexions(),
            this.recruitmentService.getCatalogStatures(),
            this.recruitmentService.getCatalogShoeSizes(),
            this.recruitmentService.getCatalogShirtSizes(),
            this.recruitmentService.getJobCandidateAppearanceByJobCandidateId(this.employee.id)
        ]).subscribe(([sizes, physicalComplexion, statures, shoeSizes, shirtSizes, appearance]) => {
            let genderSizes = sizes.filter(x => x.additional === this.employee.gender);
            const catalogs = new Array() as Array<ISelect[]>;
            catalogs.push(genderSizes);
            catalogs.push(physicalComplexion);
            catalogs.push(statures);
            catalogs.push(shoeSizes);
            catalogs.push(shirtSizes);
            this.openModalAppearance(catalogs, appearance);
            this.spinner.hide();
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private openModalAppearance(catalogs: Array<ISelect[]>, appearance: IAppearance) {
        const initialState = {
            listCatalogs: catalogs,
            title: 'Información de complexión física del candidato',
            action: 'update',
            appearance: appearance,
            module: 'dashboard',
            employeeId: this.employee.id
        };
        this.modalService.show(ModalAppearanceComponet
            , Object.assign({ initialState }
                , this.config));
    }
    private getPayCompany(id: number): void {
        this.spinner.show()
        this.organizationService.getCompanyById(id)
            .subscribe(
                (x) => {
                    this.company = x.data as IDtoCompany;
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private getWorkingDay(): void {
        if (this.child == undefined) {
            this.configGeneral.newToast('Validación', 'Ingrese un nombre de niño (a) para poder continuar', 'warning');
            return;
        }
        this.spinner.show();
        let dto = {} as IDtoJobCandidateBasic;
        dto.companyName = this.company.name;
        dto.firstName = this.employee.firstName;
        dto.lastName = this.employee.lastName;
        dto.secondLastName = this.employee.secondLastName;
        dto.imss = this.employee.imss;
        dto.curp = this.employee.curp;
        dto.jobName = this.requisition.jobDesc;
        dto.hiringDate = this.employee.hiringDate;
        dto.companyId = this.requisition.companyId;
        dto.employerRegister = this.requisition.employerRegister;
        dto.child = this.child;
        this.openingService.getWorkingDay(this.requisition.workingDayId).subscribe((res) => {
            if (res != null) {
                this.workingDay = res.data as IDtoWorkingDay;
                dto.workingDay = this.workingDay.description;
                this.getTemplateKindergarten(dto);
            } else {
                this.spinner.hide();
                this.configGeneral.newToast('Error', 'No existe una jornada laboral en este trabajador', 'error');
            }
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.message, 'error');
            });
    }
    private getTemplateKindergarten(dto: IDtoJobCandidateBasic): void {
        this.spinner.show();

        this.dashboardService.getTemplateKindergarten(dto).subscribe((res) => {
            if (res.isCorrect) {
                let file = res.data as any;
                const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
                this.spinner.hide();
                saveAs(blob, file.fileDownloadName);
                this.child = undefined;
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
            }
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.message, 'error');
            });
    }
}
